'use strict';

var React = require('react');
var Picture = require('../elements/Picture');
var PublicationTime = require('../elements/PublicationTime.jsx');
var Duration = require('../elements/Duration.jsx');
var destinations = require('../../utils/destinations');

var Destination = React.createClass({

	displayName: 'Destination',

	propTypes: {
		destination: React.PropTypes.string.isRequired,
		className: React.PropTypes.string
	},

	_getDestinationText: function (destinationType) {
		var text = '';
		if (destinations.PLAY.type === destinationType) {
			text = destinations.PLAY.name;
		} else if (destinations.FLOW.type === destinationType) {
			text = destinations.FLOW.name;
		} else if (destinations.KIDS.type === destinationType) {
			text = destinations.KIDS.name;
		}

		return text;
	},

	_getClassName: function (destinationType) {
		var className = 'svtse_episode__destination';
		if (destinations.PLAY.type === destinationType) {
			className += ' svtse_episode__destination--play';
		} else if (destinations.FLOW.type === destinationType) {
			className += ' svtse_episode__destination--flow';
		} else if (destinations.KIDS.type === destinationType) {
			className += ' svtse_episode__destination--kids';
		}

		return className;
	},

	render: function () {
		var destinationText = this._getDestinationText(this.props.destination);
		var className = this._getClassName(this.props.destination);

		if (!destinationText) {
			return false;
		}

		return (
			<span className={className}>{destinationText}</span>
		);
	}
});


module.exports = React.createClass({

	displayName: 'Episode',

	propTypes: {
		program: React.PropTypes.shape({
			title: React.PropTypes.string.isRequired
		}).isRequired,
		episode: React.PropTypes.shape({
			title: React.PropTypes.string.isRequired,
			broadcastDate: React.PropTypes.string.isRequired,
			playUrl: React.PropTypes.string.isRequired,
			cover: React.PropTypes.object.isRequired
		}).isRequired
	},


	render: function () {
		var program = this.props.program;
		var episode = this.props.episode;
		if (!(program && episode)) {
			return false;
		}

		return (
			<article className="svtse_episode">
				<a className="svtse_episode__link" href={episode.playUrl}>
					<Picture className="svtse_episode__fig" model={episode.cover} type="small">
						<div className="svtse_episode__fig-play-box">
							<span className="svtse_episode__fig-play-icon"></span>
							<span className="svtse_episode__fig-play-text">
								<Duration seconds={episode.materialLength}/>
							</span>
						</div>
					</Picture>

					<div className="svtse_episode__text">
						<h3 className="svtse_episode__title-headline">{episode.title}</h3>
						<Destination destination={program.primaryDestination} /><span className="svtse_episode__broadcast-date">Sändes <PublicationTime dateTime={episode.broadcastDate}/></span>
					</div>
				</a>
			</article>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/episodes/Episode.jsx
 **/